import Pusher from "pusher-js";

import { PUSHER_API_KEY, PUSHER_CLUSTER } from "./config/constants";

let pusherInstance: Pusher | null = null;
let pusherPromise: Promise<Pusher> | null = null;

export function initializePusher(): Promise<Pusher> {
  if (pusherPromise) return pusherPromise;

  pusherPromise = new Promise((resolve) => {
    if (pusherInstance) {
      resolve(pusherInstance);
      return;
    }

    pusherInstance = new Pusher(PUSHER_API_KEY(), {
      cluster: PUSHER_CLUSTER(),
    });

    resolve(pusherInstance);
  });

  return pusherPromise;
}

export async function getPusher(): Promise<Pusher> {
  return await initializePusher();
}
